import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const TerminatedDismissed = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 10H19.336C19.767 8.925 20 7.831 20 7C20 4.243 17.757 2 15 2C12.243 2 10 4.243 10 7C10 7.831 10.233 8.925 10.664 10H10C7.794 10 6 11.794 6 14V19C6 20.654 7.346 22 9 22H10V27C10 28.654 11.346 30 13 30H17C18.654 30 20 28.654 20 27V16H23C24.654 16 26 14.654 26 13C26 11.346 24.654 10 23 10ZM15 4C16.654 4 18 5.346 18 7C18 7.941 17.585 9.276 16.968 10.319C16.346 11.371 15.61 12 15 12C14.39 12 13.655 11.372 13.032 10.319C12.415 9.275 12 7.941 12 7C12 5.346 13.346 4 15 4V4ZM23 14H19C18.448 14 18 14.448 18 15V27C18 27.551 17.551 28 17 28H13C12.449 28 12 27.551 12 27V17C12 16.448 11.552 16 11 16C10.448 16 10 16.448 10 17V20H9C8.449 20 8 19.551 8 19V14C8 12.897 8.897 12 10 12H11.751C12.587 13.154 13.692 14 15 14C16.308 14 17.413 13.154 18.249 12H23C23.551 12 24 12.449 24 13C24 13.551 23.551 14 23 14Z" />
	</svg>
);

export default TerminatedDismissed;
